import axios from '../../helpers/axiosConfig';
import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import getBaseUrl from '../../helpers/utility';
import { AuthContext } from '../../helpers/AuthContext';
function Dcca() {
  const baseUrl = getBaseUrl();
  /*   const { authState } = useContext(AuthContext);
    const isInfocomm = authState.user && (authState.user.username === 'dcca' || authState.user.username === 'colrodi'); */



  const navigate = useNavigate();
  const [directeur, setDirecteur] = useState([]);
  const [isPaused, setIsPaused] = useState(false);

  const [direct, setDirect] = useState(null);

  const handleMouseEnter = () => setIsPaused(true);
  const handleMouseLeave = () => setIsPaused(false);

  const Etsouservice = ({ observation }) => {
    const [etsouservices, setEtsouservices] = useState([]);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get(`etsouservice/byObservation/${observation}`);
          setEtsouservices(response.data);
        } catch (error) {
          toast.error(`Erreur lors du chargement des Etsouservice pour ${observation}:`, error);
        }
      };

      fetchData();
    }, [observation]);

    return (
      <ul>
        {etsouservices.map((etsouservice) => (
          <li key={etsouservice.id}>{etsouservice.name}</li>
        ))}
      </ul>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('/directeurs');
        setDirecteur(response.data);
      } catch (err) {
        toast.error(err.response.error);
      }
    };
    fetchData();
  }, []);



  useEffect(() => {
    axios
      .get("personnel/last/directeur/2x12")
      .then((res) => {
        setDirect(res.data);
      })
      .catch((err) => console.log(err));
  }, []);


  return (
    <div className="mt-3">

      {/* {{ knp_pagination_render(directeurs) }} */}



      <div className="ml-5 mr-5 d-flex flex-column flex-md-row justify-content-between">

        <div className="mb-3 text-center">
          <img
            src="/images/logo_dcca/EMA.jfif"
            className="rounded img-fluid"
            width="280"
            alt=""
          />
        </div>

        <div className="mb-3 text-center">
          <img
            src="/images/logo_dcca/SAMSEASSIMO.jpg"
            className="rounded img-fluid"
            width="280"
            alt="Directeur"
          />

          <div className="mt-2">
            <div>Directeur de la Direction Centrale</div>
            <div>du Commissariat des Armées</div>
          </div>

          <div className="text-center mt-3">
            <h5>INTENDANT-GENERAL   </h5>
            <p>
              <strong>SAMSE ASSIMO Andriamialy </strong>
            </p>
            <p> </p>
          </div>
        </div>

        <div className="mb-3 text-center">
          <img
            src="/images/logo_dcca/DCCA.jpg"
            className="rounded img-fluid"
            width="280"
            alt=""
          />
        </div>

      </div>



      <div className="">
        <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
          <ol className="carousel-indicators">
            <li data-target="#carouselExampleCaptions" data-slide-to="0" className="active"></li>
            <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
            <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>
          </ol>
          <div className="carousel-inner ">


            <div className="carousel-item active">
              <img src="/images/app-img/d.jpg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>


            <div className="carousel-item ">
              <img src="/images/app-img/g.jpg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>

            <div className="carousel-item">
              <img src="/images/app-img/h.jpg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>
            <div className="carousel-item">
              <img src="/images/app-img/a.jpg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>

            <div className="carousel-item">
              <img src="/images/app-img/b.jpg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>

            <div className="carousel-item">
              <img src="/images/app-img/e.jpg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>

            <div className="carousel-item">
              <img src="/images/app-img/i.jpeg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>

            <div className="carousel-item">
              <img src="/images/app-img/j.jpeg" className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block text-success ">
              </div>
            </div>
          </div>
          <a className="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="carousel-control-next" href="#carouselExampleCaptions" role="button" data-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </a>
        </div>
      </div>


      <div className="row">
        <div className="col text-center text-white bg-success mb-2 mt-2">
          <h1>Les Directeurs successifs de la DCCA</h1>
        </div>
      </div>
      <div className="row">
        <div className="col alert alert-info animate__animated animate__fadeInUp">
          <div
            id="carouselExample"
            className="carousel slide"
            data-ride="carousel"
            data-interval="9000" // Temps d'intervalle du défilement
            data-pause={isPaused ? 'hover' : 'false'} // Pauser au survol
          >
            <div className="carousel-inner">
              {directeur
                .reduce((acc, item, idx) => {
                  if (idx % 4 === 0) acc.push([]); // Regrouper par 4 directeurs
                  acc[acc.length - 1].push(item);
                  return acc;
                }, [])
                .map((group, groupIdx) => (
                  <div key={groupIdx} className={`carousel-item ${groupIdx === 0 ? 'active' : ''}`}>
                    <div className="d-flex justify-content-around">
                      {group.map((directeur, key) => (
                        <div
                          key={key}
                          className="card mr-3 d-flex flex-column justify-content-between"
                          style={{ width: '200px', height: '300px', display: 'inline-block' }} // Augmentation de la largeur et définition de la hauteur
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                        >
                          <img
                            src={
                              directeur?.personnel?.filename
                                ? `${baseUrl}/images/personnels/${directeur.personnel.filename}`
                                : ``
                            }
                            alt="directeur-img"
                            className="card-img-top p-2"
                            style={{ height: '180px', objectFit: 'cover' }} // Ajuste la hauteur de l'image
                          />
                          <div className="card-body bg-success p-2 mt-auto" style={{ minHeight: '90px' }}>
                            <h6 className="card-title mb-1 text-white text-center">
                              {directeur.personnel?.grade?.name}
                              <br />
                              {directeur.personnel?.nomprenom}

                            </h6>
                            <p className="card-text text-white text-center" style={{ fontSize: '12px' }}>
                              {directeur.du} - {directeur.au}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
            </div>

            {/* Controls for Carousel */}
            <a className="carousel-control-prev" href="#carouselExample" role="button" data-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="sr-only">Previous</span>
            </a>
            <a className="carousel-control-next" href="#carouselExample" role="button" data-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>




      <div className="col-md-12">
        <div className="row">
          <div className="col-md-2 mt-3">
            <div id="accordion">
              <div className="card">
                <div className="card-header" id="headingOne">
                  <h5 className="mb-0">
                    <button className="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      SERVICES
                    </button>
                  </h5>
                </div>
                {/* className="collapse show" */}
                <div id="collapseOne" className="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                  <div className="card-body">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item">CAB</li>
                      <li class="list-group-item">SAF</li>
                      <li class="list-group-item">SAG</li>
                      <li class="list-group-item">INFOCOMM</li>
                      <li class="list-group-item">PRMP</li>
                      <li class="list-group-item">SPCM</li>
                      <li class="list-group-item">SOLDE</li>
                    </ul>
                    {/* <Etsouservice observation="SERVICE" /> */}
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header" id="headingTwo">
                  <h5 className="mb-0">
                    <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      ETABLISSEMENTS
                    </button>
                  </h5>
                </div>
                <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                  <div className="card-body">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item">ECMAG</li>
                      <li class="list-group-item">EMIH</li>
                      <li class="list-group-item">EIA</li>
                    </ul>
                    {/* <Etsouservice observation="ETABLISSEMENT" /> */}
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header" id="headingThree">
                  <h5 className="mb-0">
                    <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      ECOLES
                    </button>
                  </h5>
                </div>
                <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                  <div className="card-body">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item">CEFAA</li>
                    </ul>
                    {/* <Etsouservice observation="ECOLE" /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-10 mt-3 text-justify">
            <div className="bg-success p-3 animate__animated animate__fadeInDown text-white ">Historique de la DCCA</div>



            <div className="text-center mb-4">
            </div>

            {/* Présentation */}
            <div className="card shadow-sm">
              <div className="card-body">

                La Direction Centrale du Commissariat des Armées (DCCA) est rattachée au niveau de l’État-Major des Armées. Elle est responsable de l’administration au sein des Forces Armées Malagasy. La DCCA a pour objectif : « Tanindrazana – Fitantanana – Fahamarinana ».
                La Direction Centrale du Commissariat des Armées, communément appelée DCCA, est l’une des directions relevant de l’État-Major des Armées. Elle est chargée de la gestion administrative des Forces Armées.
                La DCCA a pour devise « Tanindrazana – Fitantanana – Fahamarinana » et est placée sous le patronage de Saint Martin, célébré chaque année le 11 novembre.
                Il est à noter que la Direction Centrale du Commissariat des Armées est implantée au camp de l’Intendant Général RASOLOMALALA Jean Jacques, CAPSAT Soanierana. Ce dernier fut le premier officier malagasy à avoir occupé le poste de Directeur de cette entité lorsqu’elle portait encore le nom de Direction de l’Administration des Forces Armées en 1972.
                <br />
                Les Etablissements consituant la DCCA sont: Etablissement Centrale des Matériels Généraux (ECMAG), Etablissement Militaire d'Habillement (EIH), Etablissement de l'Imprimerie des Arnées (EIA) et une Centre  de Formation d'Administration des Armées (CEFAA). Elle dispose de dix Bureaux Régionaux du Commissariat des Armées (BRCA) : Antsiranana,
                Antananarivo,
                Toliary,
                Morondava,
                Taolagnaro,
                Tsiroanomandidy,
                Toamasina,
                Fianarantsoa,
                Manakara,
                Mahajanga.
              </div>
            </div>

            {/* Historique */}
            {/*    <div className="card shadow-sm">
        <div className="card-header fw-bold">
        Voici un bref aperçu de l’historique de cette direction depuis sa création jusqu’à aujourd’hui : 
        </div>
        <div className="card-body">                               
              L’administration des Forces Armées Malagasy a été créée conformément au décret n°60-460 du 23 novembre 1960. Elle portait alors le nom de Direction de l’Administration Militaire (DAM). Héritée du modèle des Forces Armées françaises, elle était implantée à Ampahibe, site actuel du Ministère des Forces Armées. À l’origine, elle était chargée de la gestion du personnel, des matériels et des infrastructures techniques laissés par l’armée française.                        
              L’évolution du contexte national a entraîné une transformation de la direction. En 1972, elle fut rebaptisée Direction de l’Administration des Forces Armées (DAFA) et transférée à Soanierana, où elle se trouve encore aujourd’hui. C’est à partir de cette période que des officiers malagasy ont commencé à diriger la structure.
              <br />
              À cette époque, elle était l’unique entité responsable de la gestion financière des Forces Armées Malagasy, avec le statut de « Sous-ordonnateur unique des dépenses ».                        
              <br />
               <i className='fa fa-check' ></i> En 1976, sous l’influence de l’idéologie socialiste alors en vigueur dans le pays, elle prit le nom de Direction de l’Administration de l’Armée Populaire (DAAP).
            
              <br />
              <i className='fa fa-check' ></i> L’année 1988 constitue un tournant majeur pour l’administration des Forces Armées Malagasy avec la création de la Direction de l’Intendance de l’Armée Populaire (DIAP), conformément au décret n°88-054 du 22 février 1988. À partir de cette date, la gestion des matériels techniques fut retirée de ses attributions et confiée à une nouvelle entité, la Direction des Matériels Techniques.
            
              <br />
              <i className='fa fa-check' ></i> En 1994, la direction changea de dénomination pour la cinquième fois et devint la Direction de l’Intendance de l’Armée (DIA), selon le décret n°94-670 du 18 octobre 1994. Cette structure fut la plus pérenne, ayant existé pendant 26 ans.
            
              <br />
              <i className='fa fa-check' ></i> En 2020, la Direction Centrale du Commissariat des Armées (DCCA) fut officiellement créée par le décret n°2020-316 du 11 mars 2020, dans le cadre d’une réforme structurelle des Forces Armées Malagasy.
            
            
              Actuellement, elle est régie par l’arrêté n°9198/2024 du 04 juin 2024, qui définit son organisation ainsi que ses missions et responsabilités au sein des Forces Armées.
            
          

          <p>
            Conformément à l’article 12 dudit arrêté, la DCCA est chargée de l’administration des Forces Armées, de la gestion financière ainsi que du soutien interarmées.
          </p>
          <p>
            Enfin, la DCCA dispose désormais de son propre hymne et de son insigne distinctif.
          </p>
        </div>
      </div> */}



            {/* BRCA */}
            {/*  <div className="card shadow-sm">
        <div className="card-body">
          
            Il convient de noter que la Direction Centrale du Commissariat des Armées dispose de dix Bureaux Régionaux du Commissariat des Armées (BRCA) répartis sur l’ensemble du territoire national.                    
            Les Bureaux Régionaux du Commissariat des Armées (BRCA) constituent des démembrements de la DCCA.                    
            Il est rappelé que la Direction Centrale du Commissariat des Armées est régie par l’Arrêté n°9198 du 04 juin 2024, lequel définit son organisation ainsi que ses missions et responsabilités au sein des Forces Armées.
          
          
            Cette même date est également retenue comme date de création officielle de l’ensemble des Bureaux Régionaux du Commissariat des Armées.
          
          
            Les BRCA sont chargés d’assurer le contrôle de proximité dans leurs zones d’implantation respectives.
          
          
            Il est à préciser que la devise de chaque BRCA est inspirée de celle de la DCCA, à savoir :
            <br />
            « Tanindrazana – Fitantanana – Fahamarinana ».
        
        </div>
      </div>
 */}







            <div className="col-md-6 p-4">
              {/* 
              <a href="{{ path('home.historique') }}" className="btn btn-warning btn-sm">
                Détail historique de la DCCA
              </a>

              <a href="{{ path('home.organigramme') }}" className="btn btn-danger btn-sm">
                Organigramme de la DCCA
              </a> */}
            </div>
          </div>
        </div>
      </div>

      <div className="map-capsat mt-2">
        <div className="list-group-item list-group-item-warning">
          Google map - DCCA/CAPSAT Soanierana
        </div>

        <div className="col-md-12 card-body mt-2">
          <iframe
            className="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2695.158064852258!2d47.52372718653123!3d-18.937708513181054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x21f07e7f22278151%3A0x9bf8193928e7eab6!2sCAPSAT+Madagascar!5e1!3m2!1sfr!2smg!4v1554899491631!5m2!1sfr!2smg"
            width="100%"
            height="450"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen
          />
        </div>
      </div>

    </div>
  );
}

export default Dcca;
